import React, {useState} from "react";
import {Sidenav, Nav, Loader, Whisper} from "rsuite";
import Content from './Content';
import {linksTooltips} from "components/Tooltips/ConfigurationTooltips";
import {WhisperWrapper} from "components/Tooltips/WhisperWrapper";

const allLinks = [
    {
        name: "Devices",
        eventKey: "devices",
        tooltip: 'Click here to review, edit or delete any device assigned to your organization.  '
    },
    {
        name: "Locations",
        eventKey: "locations",
        tooltip: 'Click here to create, review, edit or delete any locations for which devices are, or will be deployed.'
    },
    {
        name: "Residents",
        eventKey: "residents",
        tooltip: 'Click here to review, edit or delete (remove) resident settings including respiration ranges, bed exit tracking settings, and visit tracking settings.'
    },
    // { name: "Users", eventKey: "users"},
    // { name: "Devices Old", eventKey: "devices-list" },
]

const ConfigurationPage = (props) => {
    const {isLoading} = props;
    const [activeLink, setActiveLink] = useState(props.pageTitle.toLowerCase());

    const chooseTemplate = () => {
        if (!props.pageSubTitle) {
            return (
                <div>
                    <strong>{props.pageTitle}</strong>
                </div>
            );
        }

        return (
            <>
                <div>{props.pageTitle}</div>
                <div>
                    <strong>{props.pageSubTitle}</strong>
                </div>
            </>
        );
    };

    const changePage = (page) => {
        props.history.push('/configuration/' + page)
        activeLink !== page && setActiveLink({activeLink: page});
    }

    const Menu = () => {
        return (
            <Sidenav appearance="subtle" className="p-0 m-0 sidebar-nav">
                <Sidenav.Body>
                    <Nav onSelect={changePage}>
                        {Array.isArray(allLinks) && allLinks.map(link => {
                            return (
                                <WhisperWrapper
                                    tooltip={linksTooltips(link.tooltip)}
                                    props={{placement: "bottom", controlId: "control-id-hover", trigger: "hover"}}
                                    key={link.eventKey}
                                >
                                    <Nav.Item
                                        eventKey={link.eventKey}
                                        key={link.eventKey}
                                        className={
                                            "nav-link" +
                                            (link.eventKey === activeLink ? " active" : "")
                                        }
                                    >
                                        {link.name}
                                    </Nav.Item>
                                </WhisperWrapper>
                            )
                        })}
                    </Nav>
                </Sidenav.Body>
            </Sidenav>
        );
    };


    return (
        <section className={`section-index configuration-page ${props.className}`}>
            <div className="row">
                <div className="menu col-md-2 p-0">
                    <Menu/>
                </div>
                <div className="col-md-10 p-0">
                    <div className="subnav m-0">
                        <div className="container h-100">
                            <div className="row justify-content-end align-items-center h-100">
                                <div className="col-md-6 mr-auto">
                                    <div className="section-nav">{chooseTemplate()}</div>
                                </div>
                                {props.subnavRight && (
                                    <div className="col-md-6 d-flex justify-content-end">
                                        {props.subnavRight}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="page-content-wrapper">
                        {isLoading ?
                            <div className="page-content with-loader">
                                <Loader size='lg' center/>
                            </div> :
                            props.children
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

ConfigurationPage.defaultProps = {
    pageTitle: "Page Title",
    pageSubTitle: null,
    className: "",
    subnavRight: null,
};

ConfigurationPage.Content = Content;

export default ConfigurationPage;
